import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import ReactSelect from 'react-select'

const Label = styled.div`
  color: rgb(120, 120, 120);
  font-size: 13px;
`

export default function Select(props) {
  const {
    options,
    value,
    label,
    onChange,
    name,
  } = props

  const [selected, setSelected] = useState()

  useEffect(() => {
    setSelected(value)
  }, [value])

  const handleChange = (option) => {
    onChange({ name, ...option })
    setSelected(option)
  }

  return (
    <div>
      <Label>{label}</Label>
      <ReactSelect
        options={options}
        value={selected}
        onChange={handleChange}
        isClearable
        isSearchable
        placeholder="- Selecione uma opção -"
      />
    </div>
  )
}

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.objectOf(PropTypes.any),
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
}

Select.defaultProps = {
  options: [],
  value: null,
}
